'use client';

import { handle_GTM_33 } from '@gtm/33';
import { handle_GTM_34 } from '@gtm/34';
import { handle_GTM_52 } from '@gtm/52';
import { handle_GTM_64 } from '@gtm/64';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { useIntersectionObservers } from 'eco-design-micro/hooks/useIntersectionObservers';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useState } from 'react';
import { ItfChooseRecommendationData } from '../setting/type';
import './index.scss';

interface ItfAniArrItem {
    name: string;
    cls: string;
}
export default function Content({ id, data = {}, isEditStatus }: ContentServerProps) {
    const { theme, title, titleColor, name, nameColor, text, textColor, btnColor, btnColorBg, btnText, btnUrl, btn2Color, btn2Text, btn2Url, pc, h5 } =
        data as ItfChooseRecommendationData;
    const prefixCls = 'choose-recommendation';
    const [enter, setEnter] = useState({
        title: isEditStatus,
        content: isEditStatus,
    });

    const arr: ItfAniArrItem[] = [
        { name: 'title', cls: `${prefixCls}-info-title` },
        { name: 'content', cls: `${prefixCls}-box` },
    ];

    useIntersectionObservers(
        {
            selectors: [`.editor-${prefixCls}-${id} .${prefixCls}-info-title`, `.editor-${prefixCls}-${id} .${prefixCls}-box`],
            onEnter: (e: Element) => {
                const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
                if (aim) {
                    setEnter((prev) => ({ ...prev, [aim.name]: true }));
                }
            },
            // onLeave: (e: Element) => {
            //     const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
            //     if (aim) {
            //         setEnter((prev) => ({ ...prev, [aim.name]: false }));
            //     }
            // },
        },
        [],
        isEditStatus,
    );

    const handle_GTM_Event = (url: string, text: string) => {
        // 1. checkout => https://us.ecoflow.com/checkouts/cn/hWN6bOi6WvZ1r1ECVcafOoKO/en-us?_r=AQABFnGHZn-cZ1lZW7AM6Pa19wIXIWn4XUcLF8yGzrkL
        const regex1 = /^https:\/\/[a-z]{2}\.ecoflow\.com\/(?:cart|checkouts)\//i;
        const regex2 = /^https:\/\/[a-z]{2}\.ecoflow\.com\//i;
        const regex3 = /^(https:\/\/)?www\.ecoflow\.com\/[a-z]{2}\//i;
        if (regex1.test(url)) {
            // 1. checkout shopify结账页
            handle_GTM_34({
                button_name: `${text}_${name}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex2.test(url)) {
            // 2. shopify 其他页
            handle_GTM_33({
                product_name: name,
                position: `Series_ChooseRecommendation_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else if (regex3.test(url)) {
            // 3. 官网网页
            handle_GTM_52({
                list_name: title,
                product_name: name,
                button_name: text,
                position: `Series_ChooseRecommendation_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        } else {
            // 4. 其他
            handle_GTM_64({
                list_name: title,
                button_name: text,
                position: `Series_ChooseRecommendation_${id}`,
                __btn_id1: `editor-${prefixCls}-${id}`,
                __btn_id2: url,
                __btn_type: 'href',
            });
        }
    };

    return (
        <GloLayout className={`editor-${prefixCls} editor-${prefixCls}-${id} theme-${theme}`} id={id} data={data} floorName={prefixCls}>
            <div className={`${prefixCls}-info`}>
                {title && (
                    <div className={`${prefixCls}-info-title ${enter?.title ? 'enter' : ''}`} style={{ color: titleColor }}>
                        {title}
                    </div>
                )}
            </div>
            <div className={`${prefixCls}-box ${enter?.content ? 'enter' : ''}`}>
                <div className={`${prefixCls}-box-img`}>
                    <EcoImg pc={pc} h5={h5} alt={name} aria-label={name} />
                </div>
                <div className={`${prefixCls}-box-content`}>
                    <div className={`${prefixCls}-box-content-info`}>
                        {name && (
                            <div className={`${prefixCls}-box-content-name`} style={{ color: nameColor }}>
                                {name}
                            </div>
                        )}
                        {text && (
                            <div className={`${prefixCls}-box-content-text`} style={{ color: textColor }}>
                                {text}
                            </div>
                        )}
                    </div>
                    <div className={`${prefixCls}-box-content-btns`}>
                        {btnUrl && btnText && (
                            <EcoLink
                                className={`${prefixCls}-box-content-btns-btn GtmModuleData-btn-href`}
                                href={btnUrl}
                                onClick={() => handle_GTM_Event(btnUrl, btnText)}
                                aria-label={btnUrl}
                                style={{ color: btnColor, backgroundColor: btnColorBg, borderColor: btnColorBg }}
                            >
                                {btnText}
                            </EcoLink>
                        )}
                        {btn2Url && btn2Text && (
                            <EcoLink
                                className={`${prefixCls}-box-content-btns-btn GtmModuleData-btn-href`}
                                href={btn2Url}
                                onClick={() => handle_GTM_Event(btn2Url, btn2Text)}
                                aria-label={btnUrl}
                                style={{ borderColor: btn2Color, color: btn2Color }}
                            >
                                {btn2Text}
                            </EcoLink>
                        )}
                    </div>
                </div>
            </div>
        </GloLayout>
    );
}
